import React, { useEffect, useRef, useState } from 'react';
import { ImageUp, Trash } from 'lucide-react';
import { Button, Typography } from '@material-tailwind/react';

const FileButton = ({ formCamp, setValue, register, reset }) => {
  const [file, setFile] = useState('');
  const fileRef = useRef();

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Verifica se o arquivo é um CSV
      if (!file.type.includes('csv')) {
        alert('Por favor, selecione um arquivo CSV válido.');
        return;
      }
      setFile(file.name); // Exibe o nome do arquivo CSV
      setValue(formCamp, event.target.files);
    }
  };

  const handleFileChange = (event) => {
    if (fileRef.current) {
      fileRef.current.value = null;
      setFile('');
      setValue(formCamp, '');
    }
  };

  useEffect(() => {
    if (reset) {
      handleFileChange();
    }
  }, [reset]);

  return (
    <div className="flex flex-row  gap-4 w-[50%] flex-wrap justify-center">
      <Button
        variant="gradient"
        color="white"
        className="flex items-center gap-3 h-8 p-5 mr-auto"
        size="md"
        onClick={() => document.getElementById('file-upload').click()}
      >
        <ImageUp color="red" />
        Enviar CSV
      </Button>
      {file && (
        <Typography
          color="red"
          className="font-bold italicunderline cursor-pointer flex gap-2 hover:text-red-700"
          onClick={handleFileChange}
        >
          {file}
          <Trash color="red" />
        </Typography>
      )}
      <input
        {...register(formCamp, { required: 'Arquivo Obrigatorio' })}
        ref={fileRef}
        type="file"
        id="file-upload"
        accept=".csv"
        style={{ display: 'none' }} // Oculta o input nativo
        onChange={handleFileUpload}
      />
    </div>
  );
};

export default FileButton;
